import { Box, Container, IconButton, Divider } from '@mui/material';
import { styled } from '@mui/system';

export const FooterWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.appBackgroundDark || 'linear-gradient(to bottom, #1A2027, #0D1117)')
    : '#f5f5f5',
  color: theme.palette.mode === 'dark' ? '#E0E0E0' : '#333',
  padding: theme.spacing(6, 0),
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #FF6B6B, #4ECDC4, #45B7D1)',
  },
}));

export const ContentWrapper = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const SocialIcons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(3),
}));

export const SocialIcon = styled(IconButton)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? '#BB86FC' : '#6A5ACD',
  margin: theme.spacing(0, 1.5),
  transition: 'all 0.3s ease',
  '&:hover': {
    color: '#4ECDC4',
    transform: 'translateY(-3px)',
    boxShadow: theme.palette.mode === 'dark'
      ? (theme.custom?.shadows?.glowPrimary || '0 4px 8px rgba(187, 134, 252, 0.3)')
      : '0 4px 8px rgba(106, 90, 205, 0.3)',
  },
}));

export const FooterDivider = styled(Divider)(({ theme }) => ({
  width: '60%',
  margin: theme.spacing(3, 'auto'),
  background: theme.palette.mode === 'dark'
    ? 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.12), transparent)'
    : 'rgba(0, 0, 0, 0.12)',
}));
